var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-component"},[(_vm.imageSrc != 'none')?_c('img',{attrs:{"src":require('@/assets/images/header-images/' + _vm.imageSrc),"alt":""}}):_vm._e(),_c('span',{staticClass:"header-title"},[_vm._v(_vm._s(_vm.toLocal(_vm.titleText)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }